import { useMedplum } from '@medplum/react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { VISIT_SUMMARY_DOC_TYPE_CODE } from '@/model/middleware-types'

export const followupStatusQueryKey = (documentReferenceId: string | undefined) =>
  ['followup-status', { documentReferenceId }] as const

export function useFollowupStatus(documentReferenceId: string | undefined) {
  const medplum = useMedplum()
  const queryClient = useQueryClient()

  const query = useQuery({
    queryKey: followupStatusQueryKey(documentReferenceId),
    enabled: !!documentReferenceId,
    staleTime: 1000 * 60 * 5,
    retry: 2,
    queryFn: async () => {
      const result = await medplum.searchOne('DocumentReference', {
        type: VISIT_SUMMARY_DOC_TYPE_CODE,
        relatesto: `DocumentReference/${documentReferenceId!}`,
      })
      return result ?? null
    },
  })

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: followupStatusQueryKey(documentReferenceId) })

  return {
    isFollowupSaved: !!query.data,
    isFollowupLoading: query.isFetching,
    isFollowupError: query.isError,
    invalidate,
  }
}
